export default "/images/vendor/quill/icons/direction-ltr.svg?d8052e6399cfca6a8a71de21b82bad55";